<template>
  <!--  <div style="overflow:hidden;">-->
  <el-tabs v-model="activeName" type="card" class="tabs-one" style="border-top: 1px solid #c8c8c8;padding-top: 20px;">
    <el-tab-pane label="公募基金" name="first">
      <myChoicePublic></myChoicePublic>
    </el-tab-pane>
    <!-- <el-tab-pane label="私募基金" name="second">
      <myChoicePrivate></myChoicePrivate>
    </el-tab-pane> -->
  </el-tabs>

  <!--    <ul class="left-menu margin-t20 border-t0">-->
  <!--      <li v-for="(item,ind) in leftMenuList" :key="ind+'menu'"-->
  <!--          :class="['left-menu-li',{'active':item.active}]"-->
  <!--          @click="leftmenuSelection(item.id)"-->
  <!--      >-->
  <!--        <span>{{item.name}}</span>-->
  <!--      </li>-->
  <!--    </ul>-->
  <!--    <div class="left-menu-con">-->
  <!--      <myChoicePublic v-show="activeMenu==0"></myChoicePublic>-->
  <!--      <myChoicePrivate v-show="activeMenu==1"></myChoicePrivate>-->
  <!--    </div>-->
  <!--  </div>-->
</template>

<script>
import myChoicePublic from "./myChoicePublic";
import myChoicePrivate from "./myChoicePrivate";
export default {
  components: {
    myChoicePublic,
    myChoicePrivate
  },
  data () {
    return {
      leftMenuList: [
        {
          id: 0,
          name: '公募基金',
          active: true
        },
        {
          id: 1,
          name: '私募基金',
          active: false
        }
      ],
      activeName: 'first',
      activeMenu: 0
    }
  },
  methods: {
    // 左侧选项
    leftmenuSelection (id) {
      const vm = this;
      vm.activeMenu = id;
      vm.leftMenuList.forEach((val, ind) => {
        val.active = false
      });
      vm.leftMenuList[id].active = true
    }
  }
}
</script>

<style lang="less" scoped>
/*左侧菜单*/
.left-menu {
  float: left;
  width: 150px;
  border: 1px solid @colorC8;
  box-sizing: border-box;
  &-li {
    height: 60px;
    border-bottom: 1px solid @colorD;
    padding: 0 25px;
    line-height: 60px;
    cursor: pointer;
    span {
      display: inline-block;
      line-height: 1.2;
      font-size: 16px;
      color: @color3;
      padding-left: 9px;
      border-left: 4px solid transparent;
    }
  }
  &-li:last-child {
    border-bottom: 0;
  }
  &-li.active span {
    font-weight: bold;
    color: @color;
    border-left: 4px solid @color;
  }
}
.left-menu-con {
  width: 1045px;
  float: right;
}
</style>

